import axios from 'axios';
import { io } from 'socket.io-client';

const API_BASE_URL = '/api';
export const PAGE_SIZE = 30;
const socket = io();

export default {
  async getCountries() {
    try {
      const response = await axios.get(`${API_BASE_URL}/countries`);
      const sortedCountries = response.data.sort((a, b) => {
        if (a.usage_count === 0 && b.usage_count === 0) {
          return a.name.localeCompare(b.name);
        }
        if (a.usage_count === 0) return 1;
        if (b.usage_count === 0) return -1;
        return b.usage_count - a.usage_count;
      });

      return sortedCountries;
    } catch (error) {
      console.error('Erreur lors de la récupération des pays:', error);
      return [];
    }
  },


  // Une page de posts, du plus récent au plus ancien ; `before` = id du dernier post déjà affiché
  async getPosts(before = 0, limit = PAGE_SIZE) {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts`, {
        params: { limit, before: before || undefined }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des posts:', error);
      return [];
    }
  },

  // Un point par pays pour la carte
  async getMapPoints() {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/map`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la carte:', error);
      return [];
    }
  },

  async getPostById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/${id}/detail`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des posts:', error);
      return [];
    }
  },

  async savePostImage(blob, filename) {
    const formData = new FormData();
    formData.append('image', blob, filename);
    return await axios.post(`${API_BASE_URL}/posts/save-post-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  async getLastMe() {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/me`);
      return response?.data || null;
    } catch (error) {
      return [];
    }
  },
  async getThemes() {
    try {
      const response = await axios.get(`${API_BASE_URL}/themes`);

      const sortedThemes = response.data.sort((a, b) => {
        if (a.usage_count === 0 && b.usage_count === 0) {
          return a.name.localeCompare(b.name);
        }
        if (a.usage_count === 0) return 1;
        if (b.usage_count === 0) return -1;
        return b.usage_count - a.usage_count;
      });

      return sortedThemes;
    } catch (error) {
      console.error('Erreur lors de la récupération des thèmes:', error);
      return [];
    }
  },

  async submitPost(postData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/posts`, postData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la soumission du post:', error);
      throw error;
    }
  },

  async getPostsByQuery(countryId, themeId, before = 0, limit = PAGE_SIZE) {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/by-query`, {
        params: {
          countryId: countryId,
          themeId: themeId,
          limit,
          before: before || undefined
        }
      });
      return response?.data?.posts || [];
    } catch (error) {
      console.error("Erreur lors de la récupération des posts:", error);
      throw error;
    }
  },

  // Traduire du texte dans la langue 
  async translateText(text, targetLanguage) {
    const response = await fetch(`https://translation.googleapis.com/language/translate/v2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer YOUR_GOOGLE_API_KEY',
      },
      body: JSON.stringify({
        q: text,
        target: targetLanguage,
      }),
    });

    const data = await response.json();
    return data.data.translations[0].translatedText;
  },

  async getReactions(postId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/${postId}/reactions`);
      return response.data;
    } catch (error) {
      return { fire: 0, heart: 0, rage: 0 };
    }
  },

  async toggleReaction(postId, reaction, action) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/posts/${postId}/reactions`,
        { reaction, action }
      );
      return response.data;
    } catch (error) {
      console.error('Erreur réaction:', error);
      return null;
    }
  },
  listenForNewPost() {
    return new Promise((resolve, reject) => {
      if (socket) {
        socket.on("newPost", (newPost) => {
          resolve(newPost);
        });
      } else {
        reject("La connexion WebSocket n'est pas encore établie");
      }
    });
  },
  // Appelle `callback` à chaque nouveau post (et pas seulement au premier) ; renvoie de quoi se désabonner
  onNewPost(callback) {
    socket.on("newPost", callback);
    return () => socket.off("newPost", callback);
  }
};
